import { Injectable } from '@angular/core';

export interface PagingParams {
  page: number;
  predicate: string;
  ascending: boolean;
}

@Injectable({ providedIn: 'root' })
export class PaginationUtil {
  parsePage(page?: string | null): number {
    return page ? parseInt(page, 10) : 1;
  }

  parsePredicate(sort?: string | null): string {
    return sort ? sort.split(',')[0] : 'id';
  }

  parseAscending(sort?: string | null): boolean {
    if (!sort) {
      return true;
    }
    const sortArray = sort.split(',');
    return sortArray.length > 1 ? sortArray[1] === 'asc' : true;
  }
}
